define('mixins/TransitionMixin',['require','lib/Podio.Browser','underscore','react-dom'],function(require) {
  var browser = require('lib/Podio.Browser');
  var _ = require('underscore');
  var ReactDOM = require('react-dom');

  return {
    onTransitionEnd: function(callback, timeout) {
      var node = ReactDOM.findDOMNode(this);
      var listener = _.once(function(e) {
        node.removeEventListener(browser.cssTransitionEndEvent, listener, false);
        callback(e);
      });

      node.addEventListener(browser.cssTransitionEndEvent, listener, false);

      setTimeout(listener, timeout || 5000);
    }
  };
});

